var MultimediaConfigurationCtrl = function ($scope) {
};
MultimediaConfigurationCtrl.$inject = ['$scope'];
angular.module('app').controller('MultimediaConfigurationCtrl',MultimediaConfigurationCtrl);